import { ITriageStore } from './types';

const initStore: ITriageStore = {
  counters: null,
  triageRequests: {
    total: 0,
    requests: [],
  },
  pagination: {
    page: 0,
    itemsPerPage: 20,
    hasMore: false,
  },
  request: null,
};

export default initStore;
